import { BreadCrumb } from '@components/breadcumb'
import { ImageOptimization } from '@components/image-optimization'
import { AboutCompany } from '@components/pages/fornecedores/franchise-page/about-company'
import { FAQFranchisePage } from '@components/pages/fornecedores/franchise-page/faq-franchise-page'
import { GroupCards } from '@components/pages/fornecedores/franchise-page/group-cards'
import { SolarEnergy } from '@components/pages/fornecedores/franchise-page/solar-energy'
import { SocialShare } from '@components/social-share'
import { useFranchise } from 'context/franchise'
import { mobile, phone } from '@utils/masks'
import { useRouter } from 'next/router'
import { BloclCallVideo } from './block-call-video'
import styles from './styles.module.scss'
import SEO from '@components/shared/seo'

export const FranchisePage = () => {
  const route = useRouter()
  const { franchise, blockCallsVideo } = useFranchise()

  let title = `${franchise.titlePage} | O melhor atendimento e serviço de instalação de energia solar do Brasil.`
  let description = `${franchise.titlePage} é uma empresa de energia solar especializada. Saiba Mais.`

  franchise.metaTitle && (title = franchise.metaTitle)
  franchise.metaDescription && (description = franchise.metaDescription)

  return (
    <div className="flex flex-1 flex-col gap-y-5 mb-36">
      <SEO
        title={title}
        description={description}
        coverImage={`${process.env.NEXT_PUBLIC_URL_BASE}/assets/portal-solar-economia-com-energia-solar.jpg`}
        canonicalUrl={franchise.canonicalUrl && franchise.canonicalUrl}
      />
      <div>
        <BreadCrumb path={route.asPath.split('?')[0]} />
      </div>
      <picture>
        <source
          media="(min-width: 800px)"
          srcSet={`/assets/portal-solar-economia-com-energia-solar.webp`}
        />
        <ImageOptimization
          className={styles.bannerImage}
          src={`/assets/simulator/energia-solar-residencial-portal-solar.webp`}
          alt="Portal Solar economia com energia solar"
        />
      </picture>
      <div className="flex justify-between flex-col md:flex-row gap-y-3">
        <div className="flex flex-col ">
          <h1 className="pb-2 font-bold size text-xl">
            {franchise?.titlePage}
          </h1>
          <b className="text-base">E-mail: {franchise?.email}</b>
          {franchise.phone && (
            <b className="text-base">Tel: {phone(franchise?.phone)}</b>
          )}
          <b className="text-base">Cel: {mobile(franchise?.mobile)}</b>
        </div>
        <SocialShare title={'Franquia'} description={'franquia portal solar'} />
      </div>
      <hr className="border-gray-500 border my-4 w-full" />
      <SolarEnergy title="Energia Solar!" className={styles.solarEnergy} />
      <GroupCards
        enableTitle={false}
        className="grid grid-cols-1 md:grid-cols-3 gap-x-4 gap-y-4 mt-44"
      />
      <br />
      <FAQFranchisePage title="Perguntas frequentes sobre Energia Solar" />
      <br />
      <AboutCompany />
      <br />
      {!!blockCallsVideo?.blockCalls?.length && (
        <>
          <h2 className="font-bold text-2xl mb-5">
            Veja algumas das nossas instalações
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
            {blockCallsVideo?.blockCalls?.map(block => (
              <BloclCallVideo blockCall={block} key={block.itemOrder} />
            ))}
          </div>
        </>
      )}
    </div>
  )
}
